<!-- 后台人员管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">版本控制</div>
      </div>
      <div class="content flex">
        <div class="form flex">
          <span>本地版本号</span>
          <div class="form-right">
            <el-input
              size="small"
              v-model="form.appVersions"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="form flex">
          <span>应用市场版本</span>
          <div class="form-right ">
            <el-input
              size="small"
              v-model="form.appstoreVersions"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="form flex">
          <span>更新状态</span>
          <div class="form-right flex">
            <el-radio-group class="" v-model="isUpload">
              <el-radio :label="0">不更新</el-radio>
              <el-radio :label="1">热更新</el-radio>
              <el-radio :label="2">应用市场更新</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form but flex">
          <span></span>
          <div class="button flex">
            <el-button
              class="sure"
              size="small"
              type="primary"
              @click="confirmBut"
              >保存</el-button
            >
            <!-- <el-button
              class="sure"
              @click="clearBut"
              type="info"
              size="small"
              plain
              >放弃</el-button
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetVersion, apiUploadVersion } from '@/api/ControlPane'

export default {
  name: '',
  props: [''],
  data() {
    return {
      form: {
        appVersions: '', // 服务器版本
        appstoreVersions: '' // 应用市场版本
      },
      isUpload: 0,
      formList: ['版本号不能为空哦！', '应用市场版本不能为空哦！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetVersion()
  },

  methods: {
    // 新增管理员
    addShopBut() {
      this.dialogTitle = '新增管理员'
      this.dialogAdmin = true
      // this.$router.push({
      //   path: '/addShop'
      // })
    },
    confirmBut() {
      if (!this.objNaN(this.form, this.formList)) {
        apiUploadVersion({
          appVersions: this.form.appVersions,
          appstoreVersions: this.form.appstoreVersions,
          isUpload: this.isUpload
        }).then(res => {
          if (res.status === 0) {
            this.$message({
              type: 'success',
              message: res.msg
            })
          }
        })
      }
    },
    clearBut() {},
    // 接口
    // 获取版本号
    GetVersion() {
      apiGetVersion().then(res => {
        if (res.status === 0) {
          this.form.appVersions = res.data.APPSTORE_VERSIONS
          this.form.appstoreVersions = res.data.APP_VERSIONS
          this.isUpload = res.data.IS_UPLOAD
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    padding: 30px 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .form {
      align-items: center;

      width: 50%;
      padding: 10px 0;
      span {
        text-align: right;
        width: 30%;
        padding-right: 10px;
      }
      .form-right {
        width: 70%;
        align-items: flex-start;
      }
    }
  }
}
.dialog {
}
</style>
